<template>
  <b-modal
    id="modal-manage-flag"
    ref="modal"
    v-model="open"
    size="ov-custom"
    centered
    hide-footer
    title="Manage Flag"
  >
    <b-overlay
      :show="loading"
      blur="10px"
      opacity="0.30"
      rounded="sm"
      variant="light"
    >
      <ValidationObserver
        ref="manageFlag"
        v-slot="{ handleSubmit }"
        slim
      >
        <b-form
          class="my-8"
          @submit.prevent="handleSubmit(onClickManageFlag)"
        >
          <b-row class="mb-4">
            <b-col
              cols="9"
            >
              <b-form-group
                label="Flag Name"
                label-for="h-name"
                label-cols-md="3"
              >
                <b-form-input
                  id="Flag Name"
                  v-model="flagOptions.name"
                  placeholder="Enter Flag Name"
                  autocomplete="nope"
                  :disabled="true"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <b-row
            class="mb-4"
          >
            <b-col
              cols="9"
              md="6"
            >
              <b-form-group
                label="Flaged By"
                label-for="h-name"
                label-cols-md="3"
              >
                <b-col
                  v-if="flagOptions.type === 'flag_8' || flagOptions.type === 'flag_7' || flagOptions.is_system === false"
                  cols="6"
                >
                  <b-form-checkbox
                    id="checkbox-1"
                    v-model="flagOptions.is_staff_enable"
                    class="mb-2"
                    :disabled="flagOptions.type === 'flag_7'"
                  >
                    Staff Enable
                  </b-form-checkbox>
                </b-col>
                <b-col
                  v-if="flagOptions.type !== 'flag_7' || flagOptions.is_system === false"
                  cols="6"
                >
                  <b-form-checkbox
                    id="checkbox-2"
                    v-model="flagOptions.is_merchant_enable"
                  >
                    Merchant Enable
                  </b-form-checkbox>
                </b-col>
              </b-form-group>
            </b-col>
            <b-col
              v-if="flagOptions.type === 'flag_8' && (flagOptions.is_staff_enable || flagOptions.is_merchant_enable)"
              cols="9"
              md="6"
            >
              <b-col
                v-if="flagOptions.is_staff_enable"
                cols="6"
                md="9"
              >
                <b-form-group
                  label="Staff Maximum Attempt"
                  label-for="h-name"
                  label-cols-md="7"
                >
                  <v-select
                    v-model="flagOptions.max_attempt_staff"
                    :options="attemptOptions"
                    :reduce="option => option.value"
                    label="name"
                    class="mb-1"
                  >
                    <template v-slot:option="option">
                      {{ option.name }}
                    </template>
                  </v-select>
                </b-form-group>
              </b-col>
              <b-col
                v-if="flagOptions.is_merchant_enable"
                cols="6"
                md="9"
              >
                <b-form-group
                  label="Merchant Maximum Attempt"
                  label-for="h-name"
                  label-cols-md="7"
                >
                  <v-select
                    v-model="flagOptions.max_attempt_merchant"
                    :options="attemptOptions"
                    :reduce="option => option.value"
                    label="name"
                    class="mb-1"
                  >
                    <template v-slot:option="option">
                      {{ option.name }}
                    </template>
                  </v-select>
                </b-form-group>
              </b-col>
            </b-col>
          </b-row>
          <b-row
            v-if="flagOptions.is_system === false"
            class="mb-1"
          >
            <b-col
              cols="9"
              md="6"
            >
              <b-form-group
                label="Status"
                label-for="h-active"
                label-cols-md="3"
              >
                <b-col
                  cols="6"
                >
                  <b-form-checkbox
                    id="checkbox-3"
                    v-model="flagOptions.is_active"
                  >
                    Active
                  </b-form-checkbox>
                </b-col>
              </b-form-group>
            </b-col>
          </b-row>
          <b-col
            class="mb-2"
            offset-md="4"
          >
            <b-button
              v-can="'flag-edit'"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              type="submit"
              variant="primary"
              class="mr-1"
              :disabled="flagOptions.type === 'flag_7'"
            >
              Submit
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              :disabled="flagOptions.type === 'flag_7'"
              @click="clearForm"
            >
              Clear
            </b-button>
          </b-col>
        </b-form>
      </ValidationObserver>
    </b-overlay>
  </b-modal>
</template>

<script>
import {
  BModal,
  BOverlay,
  VBModal,
  BRow,
  BCol,
  BForm,
  BFormCheckbox,
  BButton,
  BFormGroup,
  BFormInput,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import Ripple from 'vue-ripple-directive'
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const flagRepository = RepositoryFactory.get('flag')

export default {
  name: 'ManageFlag',
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  components: {
    BModal,
    BOverlay,
    BRow,
    BCol,
    BForm,
    BFormCheckbox,
    BButton,
    BFormGroup,
    BFormInput,
    vSelect,
  },
  mixins: [SuccessMessage, ErrorMessage],
  data() {
    return {
      open: false,
      signatureOpen: false,
      modalLoading: false,
      loading: false,
      id: null,
      items: {},
      perPage: 10,
      flagOptions: {},
      attemptOptions: [
        { name: 'Any', value: -1 },
        { name: '1', value: 1 },
        { name: '2', value: 2 },
        { name: '3', value: 3 },
        { name: '4', value: 4 },
        { name: '5', value: 5 },
      ],
    }
  },
  methods: {
    async fetchFlagDetails() {
      try {
        const { data } = (await flagRepository.fetchFlagDetails(this.id)).data
        this.flagOptions = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async onClickManageFlag() {
      try {
        this.loading = true
        const payload = {
          is_staff_enable: this.flagOptions.is_staff_enable,
          is_merchant_enable: this.flagOptions.is_merchant_enable,
          max_attempt_staff: this.flagOptions.max_attempt_staff,
          max_attempt_merchant: this.flagOptions.max_attempt_merchant,
          is_active: this.flagOptions.is_active,
        }
        const res = await flagRepository.updateFlagDetails(this.flagOptions.id, payload)
        if (res.status === 200) {
          this.open = false
          this.showSuccessMessage(`${this.flagOptions.name}  updated successfully`)
          this.$parent.onClickRefresh()
        } else {
          this.showErrorMessage(`Cannot Update ${this.flagOptions.name}  Status Settings`)
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.loading = false
    },
    async openModal(id) {
      this.open = true
      this.id = id
      this.modalLoading = true
      this.modalLoading = false
      await this.fetchFlagDetails()
    },
    clearForm() {
      if (this.flagOptions.type === 'flag_8' || this.flagOptions.type === 'flag_7') {
        this.flagOptions.is_staff_enable = false
      }

      if (this.flagOptions.type !== 'flag_7') {
        this.flagOptions.is_merchant_enable = false
      }
    },
  },
}
</script>
  <style scoped>
  b-form-checkbox{
    margin-bottom: 10px;
  }
    @media (min-width: 767px) {
      .status-bar {
        padding : 1rem;
      }
    }
  .custom-control {
      position: relative;
      z-index: 1;
      display: block;
      min-height: 1.45rem;
      margin-bottom: 15px;
    }
  </style>
